module.exports = __webpack_public_path__ + "static/media/iotfarm.81ee2f5c.png";